// Responsive breakpoints - More precise device detection
export const BREAKPOINTS = {
  // Mobile device-specific breakpoints
  MOBILE_SM: 320,   // iPhone SE, small Android phones
  MOBILE_MD: 375,   // iPhone 12/13/14
  MOBILE_LG: 428,   // iPhone 14 Plus, large phones
  MOBILE_XL: 480,   // Very large phones in portrait
  
  // Foldable/dual-screen devices
  SURFACE_DUO: 540, // Surface Duo unfolded - should use tablet layout
  
  // Custom tablet breakpoints for precise control
  TABLET_SM: 768,   // iPad Mini
  TABLET_MD: 834,   // iPad Air
  TABLET_LG: 1024,  // iPad Pro
  
  // Desktop - Higher threshold to ensure proper desktop detection
  DESKTOP: 1200,    // Desktop - Two column layout starts here (standard desktop minimum)
};

// CSS media queries for JavaScript usage
export const MEDIA_QUERIES = {
  MOBILE_SM: `(min-width: ${BREAKPOINTS.MOBILE_SM}px)`,
  MOBILE_MD: `(min-width: ${BREAKPOINTS.MOBILE_MD}px)`,
  MOBILE_LG: `(min-width: ${BREAKPOINTS.MOBILE_LG}px)`,
  MOBILE_XL: `(min-width: ${BREAKPOINTS.MOBILE_XL}px)`,
  SURFACE_DUO: `(min-width: ${BREAKPOINTS.SURFACE_DUO}px)`,
  TABLET_SM: `(min-width: ${BREAKPOINTS.TABLET_SM}px)`,
  TABLET_MD: `(min-width: ${BREAKPOINTS.TABLET_MD}px)`,
  TABLET_LG: `(min-width: ${BREAKPOINTS.TABLET_LG}px)`,
  DESKTOP: `(min-width: ${BREAKPOINTS.DESKTOP}px)`,
  
  // Portrait-specific queries
  TABLET_PORTRAIT: '(min-width: 768px) and (max-width: 1024px) and (orientation: portrait)',
  TABLET_LANDSCAPE: '(min-width: 768px) and (orientation: landscape)',
  
  // Specific device targeting
  IPAD_MINI_PORTRAIT: '(min-width: 768px) and (max-width: 834px) and (orientation: portrait)',
  IPAD_AIR_PORTRAIT: '(min-width: 834px) and (max-width: 1024px) and (orientation: portrait)',
  IPAD_PRO_PORTRAIT: '(min-width: 1024px) and (max-width: 1194px) and (orientation: portrait)',
};

// Device detection helper
export const DEVICE_TYPES = {
  MOBILE: 'mobile',
  TABLET: 'tablet',
  DESKTOP: 'desktop',
};